import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { BackIcon, LoadingIcon, DotsIcon, RemoveIcon, ZoomIcon, AddIcon, CheckIcon } from '../../Svg/Index.js'
import { SET_PROFILE_OPEN, SET_TYPE } from '../../Actions/Sidebar'
import { GET_PROFILE_BY_ID, SEND_REQUEST, REVOKE_REQUEST, ADD_BLOCK, UNBLOCK, REMOVE_FRIEND } from '../../Actions/User'
import { CHECK_EXISTING_OR_NEW } from '../../Actions/Chat'
import { withRouter } from 'react-router-dom';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Filtered from '../../Containers/Wazzup/Filtered.js'

class ProfileTheirs extends Component {

    state = {
        profileTheirs: null,
        subnavOpen: false,
        tab: 'bio',
        photoIndex: 0,
        lightboxOpen: false,
        dialogActive: false,
        remove_friend_id: null,
        avatarOpen: false,
    }

    componentDidMount() {
        this.props.actions.GET_PROFILE_BY_ID(this.props.sidebar.profile_theirs_open).then(profileTheirs => {
            setTimeout(() => {
                this.setState({profileTheirs: profileTheirs})
            }, 500)
        })
    }

    handleAddFriend = (id) => {
        this.props.actions.SEND_REQUEST(id) 
        this.setState({
            sent: true
        })
    }

    revokeFriendRequest(id) {
        id = this.props.user.sent_friend_requests.filter((item)=> {
            if(item.friend) {
                return item.friend._id === id
            } else {
                return false;
            }
        })
        this.props.actions.REVOKE_REQUEST(id[0]._id)
    }

    handleFriendRemove = ()=> {
        this.props.actions.REMOVE_FRIEND(this.state.remove_friend_id).then(res => {
            this.setState({dialogActive: false})
        })
    }

    handleCloseProfile = ()=> {
        this.props.actions.SET_PROFILE_OPEN(false);
        // this.props.history.push('/wazzup')
    }

    handlePostsShow = (id, name)=> {
        this.props.history.push('/loading')
        setTimeout(()=> {
            this.props.history.push({
                pathname: `/wazzup/filtered/${id}`,
                filteredUserName: name
            })
        })
        
    }

    handleFriendChat = () => {
        const { _id } = this.state.profileTheirs
        this.props.actions.CHECK_EXISTING_OR_NEW(_id).then(thread => {
            if(thread._uuid) {

                this.props.history.push('/loading')

                //Thread found
                this.props.history.push({
                    pathname: `/chat`,
                    threadId: thread._uuid,
                    user: this.state.profileTheirs
                })

            } else {
                //Thread not found
                this.props.history.push('/loading')

                this.props.history.push({
                    pathname: `/chat`,
                    newChat: true,
                    user: this.state.profileTheirs
                })
                
            }
        })
    }

    handleBlock = () => {
        this.props.actions.ADD_BLOCK(this.props.sidebar.profile_theirs_open).then(res => {
        })
    }

    handleUnblock = () => {
        this.props.actions.UNBLOCK(this.props.sidebar.profile_theirs_open).then(res => {
        })
    }

    componentWillReceiveProps() {
        setTimeout(()=> {
            this.props.actions.GET_PROFILE_BY_ID(this.props.sidebar.profile_theirs_open).then(profileTheirs => {
                setTimeout(() => {
                    this.setState({profileTheirs: profileTheirs})
                }, 500)
            })
        })
    }

    handleShowFriends = ()=> {
        const { _id } = this.state.profileTheirs
        this.props.actions.SET_TYPE('friends_theirs', _id);
    }

    handleSubnavOpen = ()=> {
        this.setState({
            subnavOpen: true
        })
    }

    handleSubnavClose = ()=> {
        this.setState({
            subnavOpen: false
        })
    }

    setTab = (type)=> {
        this.setState({
            tab: type
        })
    }

    render() {
        const { profileTheirs, photoIndex, lightboxOpen, dialogActive, avatarOpen } = this.state;
        const you = this.props.user;
        let isBlocked = false;
        
        if(this.props.user.blocked_users && profileTheirs) {
            isBlocked = !!this.props.user.blocked_users.filter(r => r._id === profileTheirs._id).length
        }

        let isAFriendOfYours = '';
        let hasPendingFriendRequest = '';
        let isYou = false;

        let images = [];
       

        if(profileTheirs) {
            
            isAFriendOfYours = !!you.friends.filter(r => r._id === profileTheirs._id).length;
            hasPendingFriendRequest = !!you.sent_friend_requests.filter((r) => {
                if(!r.friend) return; 
                return r.friend._id === profileTheirs._id
            }).length
            isYou = profileTheirs._id === you._id;

            if(profileTheirs.photos) {
                profileTheirs.photos.forEach((item)=> {
                    images.push(item.photo.user_photo)
                })
            }

        }


        return (
            <>
                <div className="c-sidebar__controls c-sidebar__controls--alt">
                    {
                        (profileTheirs && profileTheirs._id !== 1) && (
                            <button className="c-bare-btn c-sidebar-edit c-btn--with-icon" onClick={this.handleSubnavOpen}>
                                <DotsIcon />
                            </button>
                        )
                    }
                </div>

                {
                    this.state.subnavOpen && (
                        <div className="c-sidebar__inner-nav">
                            <div className="c-sidebar__inner-nav__inner">
                                 {
                                    !isBlocked && (
                                        <button className="c-btn  c-btn--primary c-btn--wide c-btn--compact" onClick={this.handleBlock}>Deze persoon blokkeren</button>
                                    )
                                }
                                {
                                    isBlocked && (
                                        <button className="c-btn c-btn--primary  c-btn--wide c-btn--compact" onClick={this.handleUnblock}>Blokkeren opheffen</button>
                                    )
                                }
                                <button className="c-btn c-btn--secondary c-btn--wide c-btn--compact" onClick={this.handleSubnavClose}>Annuleren</button>
                            </div>
                        </div>
                    )
                }

                <div className="c-sidebar-profile c-user">
                    <button className="c-btn c-btn--back" onClick={this.handleCloseProfile}>
                        <BackIcon />
                    </button>

                    {
                        !profileTheirs && (
                            <div className="c-sidebar-loader">
                                <LoadingIcon />
                            </div>
                        )
                    }

                    <div className="c-sidebar-profile__inner">
                        
                        {
                            profileTheirs && (
                                <>
                                    <figure className="c-user__media" onClick={() => this.setState({ avatarOpen: true })}>
                                        <img src={profileTheirs.avatar.user_avatar} alt=""/>
                                    </figure>
                                    <span className="c-user__name">{profileTheirs.display_name}</span>
                                    {
                                        profileTheirs.city && (
                                            <span className="c-user__city">{profileTheirs.city}</span>
                                        )
                                    }
                                    {
                                        profileTheirs.pronouns && (
                                            <span className="c-user__city">{profileTheirs.pronouns}</span>
                                        )
                                    }

                                    <div className="flex-buttons">
                                    {
                                        !isYou && (
                                            <>
                                                {
                                                    profileTheirs._id !== 1 && (
                                                        <button className="c-btn c-btn--primary-alt c-btn--compact-alt" onClick={this.handleShowFriends}>Vrienden ({profileTheirs.friends.length})</button>
                                                    )
                                                }
                                                <button className="c-btn c-btn--primary-alt c-btn--compact-alt" onClick={this.handleFriendChat}>Stuur bericht</button>
                                                {
                                                    profileTheirs._id !== 1 && (
                                                        <>
                                                            {
                                                                (!hasPendingFriendRequest && !isAFriendOfYours) && (
                                                                    <button className="c-btn c-btn--secondary c-btn--wide c-btn--compact-alt" onClick={ () => this.handleAddFriend(profileTheirs._id) }>Stuur vriendschapsverzoek</button>
                                                                )
                                                            }

                                                            {
                                                                (!hasPendingFriendRequest && isAFriendOfYours) && (
                                                                    <button className="c-btn c-btn--positive c-btn--compact-alt c-btn--wide" onClick={ () => this.setState({dialogActive: true, remove_friend_id: profileTheirs._id}) }>Jullie zijn vrienden <CheckIcon /></button>
                                                                )
                                                            }

                                                            {
                                                                hasPendingFriendRequest && (
                                                                    <button className="c-btn c-btn--primary-alt c-btn--wide c-btn--compact-alt" onClick={ () => this.revokeFriendRequest(profileTheirs._id) }>Vriendverzoek intrekken</button>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                    </div>

                                    {
                                        dialogActive && (
                                            <div className="c-dialog">
                                                <div className="c-dialog__inner">
                                                    <h2>Weet je het zeker?</h2>
                                                    <button className="c-btn c-btn--primary" onClick={this.handleFriendRemove}>Ja, verwijder</button>
                                                    <button className="c-btn c-btn--primary" onClick={ () => this.setState({dialogActive: false}) }>Nee, annuleren</button>
                                                </div>
                                            </div>
                                        )
                                    }

                                    <div className="c-tabs">
                                        <div className={`c-tab ${this.state.tab === 'bio' ? 'is-active' : ''}`} onClick={() => this.setTab('bio')}>
                                            <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><path className="svg-element" d="M10,12 L0,12 L0,14 L10,14 L10,12 Z M16,4 L0,4 L0,6 L16,6 L16,4 Z M0,10 L16,10 L16,8 L0,8 L0,10 Z M0,0 L0,2 L16,2 L16,0 L0,0 Z" fill="#BA95F7" fillRule="nonzero"></path></g></svg>
                                        </div>
                                        <div className={`c-tab ${this.state.tab === 'photos' ? 'is-active' : ''}`} onClick={() => this.setTab('photos')}>
                                            <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><path className="svg-element" d="M18,16 L18,2 C18,0.9 17.1,0 16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 Z M5.5,10.5 L8,13.51 L11.5,9 L16,15 L2,15 L5.5,10.5 Z" fill="#BA95F7" fillRule="nonzero"></path></g></svg>
                                        </div>
                                        <div className={`c-tab ${this.state.tab === 'posts' ? 'is-active' : ''}`}  onClick={() => this.setTab('posts')}>
                                            <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><path className="svg-element" d="M16,0 L1.99,0 C0.88,0 0.01,0.89 0.01,2 L0,16 C0,17.1 0.88,18 1.99,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.89 17.1,0 16,0 Z M16,12 L12,12 C12,13.66 10.65,15 9,15 C7.35,15 6,13.66 6,12 L1.99,12 L1.99,2 L16,2 L16,12 Z" fill="#BA95F7" fillRule="nonzero"></path></g></svg>
                                        </div>
                                    </div>

                                    <div className="c-tab-container">

                                        {
                                            this.state.tab === 'bio' && (

                                                profileTheirs.bio ? 
                                                    <div className="c-user__bio">
                                                        <p>
                                                            {profileTheirs.bio.split('\n').map((item, key) => {
                                                                return <span key={key}>{item}<br/></span>
                                                            })}
                                                        </p>
                                                    </div>
                                                :
                                                    <>
                                                        <div className="c-user__empty">
                                                            Nog geen bio<br />
                                                            🤐
                                                        </div>
                                                    </>
                                                
                                            )
                                        }

                                        {
                                            this.state.tab === 'posts' && (
                                                <Filtered />
                                            )
                                        }

                                        {
                                            this.state.tab === 'photos' && (
                                                <div className={`c-user__photos ${profileTheirs.photos.length ? 'has-photos' : ''}`}>
                                                    {
                                                        profileTheirs.photos.length ? 
                                                        <div className="c-user__photos-grid">
                                                            {
                                                                profileTheirs.photos.map((item, i) =>
                                                                    <div key={`photo-${i}`} className="c-user__photo" style={{backgroundImage: `url(${item.photo.user_photo})`}}>
                                                                        <div className="c-user__photo-buttons">
                                                                            <div className="c-user__photo-button c-user__photo-zoom c-user__photo-zoom--full" onClick={() => this.setState({ lightboxOpen: true, photoIndex: i })}>
                                                                                <ZoomIcon />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>   
                                                    :
                                                        <>
                                                            <div className="c-user__empty">
                                                                Nog geen foto's
                                                                <br />
                                                                📸
                                                            </div>
                                                        </>
                                                    }
                                                   

                                                    {lightboxOpen && (
                                                        <Lightbox
                                                            mainSrc={images[photoIndex]}
                                                            nextSrc={images[(photoIndex + 1) % images.length]}
                                                            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                                            onCloseRequest={() => this.setState({ lightboxOpen: false })}
                                                            onMovePrevRequest={() =>
                                                            this.setState({
                                                                photoIndex: (photoIndex + images.length - 1) % images.length,
                                                            })
                                                            }
                                                            onMoveNextRequest={() =>
                                                            this.setState({
                                                                photoIndex: (photoIndex + 1) % images.length,
                                                            })
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            )
                                        }
                                    </div>
                                </>
                            )
                        }
                        {avatarOpen && (
                            <Lightbox
                                mainSrc={profileTheirs.avatar.user_avatar}
                                onCloseRequest={() => this.setState({ avatarOpen: false })}
                            />
                        )}
                    </div>
                </div>

            </>
            
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        sidebar: state.sidebar,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_PROFILE_OPEN, GET_PROFILE_BY_ID, SEND_REQUEST, REVOKE_REQUEST, ADD_BLOCK, UNBLOCK, CHECK_EXISTING_OR_NEW, SET_TYPE, REMOVE_FRIEND}, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileTheirs))